__turbopack_context__.v({
  "actions": "CookieConsentBanner-module-scss-module__CUKcba__actions",
  "banner": "CookieConsentBanner-module-scss-module__CUKcba__banner",
  "button": "CookieConsentBanner-module-scss-module__CUKcba__button",
  "buttonAccept": "CookieConsentBanner-module-scss-module__CUKcba__buttonAccept",
  "buttonReject": "CookieConsentBanner-module-scss-module__CUKcba__buttonReject",
  "content": "CookieConsentBanner-module-scss-module__CUKcba__content",
  "description": "CookieConsentBanner-module-scss-module__CUKcba__description",
  "fadeIn": "CookieConsentBanner-module-scss-module__CUKcba__fadeIn",
  "link": "CookieConsentBanner-module-scss-module__CUKcba__link",
  "overlay": "CookieConsentBanner-module-scss-module__CUKcba__overlay",
  "slideUp": "CookieConsentBanner-module-scss-module__CUKcba__slideUp",
  "title": "CookieConsentBanner-module-scss-module__CUKcba__title",
});
